<template>
<div class="invoice-wrapper">
	<div class="invoice" id="invoice">
		<div class="invoice__body">
			<!-- Header -->
			<div class="invoice__header">
				<div class="invoice__image">
					<!-- <div class="is-loading" v-if="!logo"></div> -->
					<img
						class="invoice__logo"
						crossorigin="anonymous"
						:src="logo"
						:alt="storeName"
						@load="onLogoLoaded"
						v-if="logo">
				</div>
				<div class="invoice__info">
					<div class="invoice__title">Invoice #<span class="invoice__id">{{ id }}</span></div>
					<div class="invoice__date text-right">
						<span>Date: </span>
						<span class="invoice__date-value">{{ formatDate(date) }}</span>
					</div>
					<div class="invoice__date">
						<span>Due Date: </span>
						<span class="invoice__date-value">{{ formatDate(dueDate) }}</span>
					</div>
				</div>
			</div>

			<!-- Customer -->
			<div class="invoice__customer">
				<div class="invoice__customer__top">
					<div class="invoice__customer__name">{{ customerName }}</div>
					<div class="invoice__status">
						<div class="invoice-status" :class="status">{{ status }}</div>
					</div>
				</div>
				<div>
					<!-- Email -->
					<div class="invoice__customer__item invoice__customer__email">
						<!-- <i class="material-icons md-sm">email</i> -->
						<a target="_blank" :href="`mailto:${customerEmail}`">{{ customerEmail }}</a>
					</div>
					<!-- Phone -->
					<div class="invoice__customer__item invoice__customer__phone">
						<!-- <i class="material-icons md-sm">phone</i> -->
						<span>{{ customerPhone }}</span>
					</div>
					<!-- Address -->
					<div class="invoice__customer__item invoice__customer__address">
						<!-- <i class="material-icons md-sm">location_city</i> -->
						<div class="invoice__customer__street">{{ customerAddress }}</div>
					</div>
					<!-- Notes -->
					<div class="invoice__customer__item invoice__customer__notes" v-if="notes">
						<i class="material-icons md-sm">class</i>
						<span>Notes: {{ notes }}</span>
					</div>
				</div>
			</div>

			<!-- Items -->
			<div class="invoice__items">
				<div class="invoice__items__header">
					<div>Items</div>
					<div>Price</div>
				</div>
				<div class="invoice__items__list">
					<invoice-item
						v-for="(item, index) in items"
						:key="index"
						:item="item">
					</invoice-item>
				</div>
			</div>

			<!-- Total -->
			<div class="invoice__total">
				<div class="invoice__total__label">Total</div>
				<div class="invoice__total__price">{{ formatMoney(total) }}</div>
			</div>
		</div>

		<!-- Footer -->
		<div class="invoice__footer">
			<div v-if="isBankTransfer">
				<div class="mb-3">Silahkan lakukan pembayaran atas invoice tersebut ke <span v-if="bankAccounts.length > 1">salah satu </span>rekening berikut:</div>
				<div class="row">
					<div
						class="col-sm-6 mb-3"
						v-for="(bankAccount, index) in bankAccounts"
						:key="index">
						<div class="text-bold">Bank: {{ bankAccount.label }}</div>
						<div>
							<span>No. Rek: </span>
							<span
								class="text-bold cur-p"
								v-tooltip="'Click to Copy'"
								@click="copy(bankAccount.account_number)">
								{{ bankAccount.account_number }}
							</span>
						</div>
						<div>Atas Nama: {{ bankAccount.account_name }}</div>
					</div>
				</div>
			</div>
			<div class="invoice__copyright">
				<span>Powered By</span>
				<img :src="logo" alt="Ostock.id">
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import InvoiceItem from './InvoiceItem.vue';
import {
	imageElemtoBase64,
	copyToClipboard,
} from '@/lib/helper';
import {
	s3Url,
	ooBankAccounts,
	orderOnlineImage,
} from '@/lib/statics';

export default {
	name: 'InvoicePlain',
	props: {
		timezone: {
			type: String,
			default: 'Asia/Jakarta',
		},
		customer: {
			type: Object,
			default: () => ({ name: '', phone: '', email: '' }),
		},
		bankAccounts: {
			type: Array,
			default: () => ooBankAccounts,
		},
		items: {
			type: Array,
			default: () => [],
		},
		notes: {
			type: String,
		},
		id: {
			type: Number,
		},
		date: {
			type: String,
		},
		dueDate: {
			type: String,
		},
		status: {
			type: String,
			default: 'unpaid',
		},
		logoUrl: {
			type: String,
			default: '',
		},
		payment: {
			type: Object,
		},
		type: {
			type: String,
			default: '',
		},
	},
	components: {
		InvoiceItem,
	},
	data() {
		return {
			orderDetail: null,
			logoData: orderOnlineImage,
		};
	},
	methods: {
		...mapActions({
		}),
		onLogoLoaded(e) {
			if (this.logoData === '') {
				const img = e.target;
				const image = imageElemtoBase64(img);
				this.logoData = image.data;
				// this.setLogoData(image.data);
			}
		},
		copy(text) {
			copyToClipboard(text);
			this.$notify({
				group: 'app',
				title: 'Account Number',
				text: 'Successfully Copied',
				type: 'success',
			});
		},
		formatDate(date) {
			return dayjs(date).format('DD-MM-YYYY');
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			appLogo: 'appLogo',
		}),
		customerName() {
			return this.customer.name;
		},
		customerEmail() {
			return this.customer.email;
		},
		customerPhone() {
			return this.customer.phone;
		},
		customerAddress() {
			const address = this.customer.address;
			return address;
		},
		total() {
			let total = 0;
			for (let index = 0; index < this.items.length; index++) {
				const item = this.items[index];
				total += item.price;
			}
			return total;
		},
		storeName() {
			return 'Ostock.id';
		},
		logo() {
			let logoUrl = this.logoUrl;
			logoUrl = logoUrl.replace('https://cdn.ostock.id', s3Url);
			if (this.logoData && this.logoData !== '') {
				logoUrl = this.logoData;
			}
			return logoUrl;
		},
		paymentMethod() {
			return this?.payment?.method ?? 'bank_transfer';
		},
		isBankTransfer() {
			return this.paymentMethod === 'bank_transfer';
		},
	},
	created() {
	},
	watch: {
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';
@import '../assets/scss/partials/_invoice.scss';
</style>
